import { useContext } from 'react'

import theme from 'theme'

import { AccordionContext } from './Accordion'

export default function Footer(props) {
  const { expanded } = useContext(AccordionContext)

  return expanded ? (
    <div
      css={{
        width: '100%',
        minHeight: theme.space[2],
        backgroundColor: theme.colors.panel[0],
        borderBottomLeftRadius: theme.borderRadius[0],
        borderBottomRightRadius: theme.borderRadius[0]
      }}
      {...props}
    />
  ) : null
}
